import { inSSRContext } from '@/lego/utils/render/ssr';

export function isMobile() {
  if (inSSRContext()) return false;

  const ua = navigator.userAgent;

  return (
    /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua) ||
    /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)
  );
}
